export enum AttemptOutcomeEnum {
  FAILED = 'FAILED',
  PASSED = 'PASSED',
  SCORED = 'SCORED',
}
